import { useInteractionHandler } from './use-interaction-handler.js';

function useInputChange({ onChange: onChangeIn, recordingKey, ...restProps }) {
    const onChange = useInteractionHandler(onChangeIn, { eventName: 'change', recordingKey }, [
        onChangeIn,
    ]);
    return { ...restProps, onChange };
}

export { useInputChange };
//# sourceMappingURL=use-input-change.js.map
